// @flow

import React from 'react';
import { isBrowser } from 'react-device-detect';
import Job from 'components/Job';
import JobMobile from 'components/JobMobile';

type Props = {
  jobs: Array<any>,
  user: any,
  isCurrentUser: boolean,
  handleLike: Function
};

export default ({ jobs, user, isCurrentUser, handleLike }: Props) => (
  <div className="jobs-items">
    {
      isBrowser
        ? jobs.map((job, index) => <Job
          key={job.id}
          index={index}
          job={job}
          user={user}
          isCurrentUser={isCurrentUser}
          handleLike={handleLike}
          trackEventName="view_company_job"
          trackClickName="click_on_company_job"
        />)
        : jobs.map((job, index) => <JobMobile
          key={job.id}
          index={index}
          job={job}
          user={user}
          isCurrentUser={isCurrentUser}
          handleLike={handleLike}
          trackEventName="view_company_job"
          trackClickName="click_on_company_job"
        />)
    }
  </div>
);
